'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PivotTableAxis = undefined;

var _isArray = require('d2-utilizr/lib/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

var _arrayContains = require('d2-utilizr/lib/arrayContains');

var _arrayContains2 = _interopRequireDefault(_arrayContains);

var _arrayPluck = require('d2-utilizr/lib/arrayPluck');

var _arrayPluck2 = _interopRequireDefault(_arrayPluck);

var _arraySort = require('d2-utilizr/lib/arraySort');

var _arraySort2 = _interopRequireDefault(_arraySort);

var _arrayUnique = require('d2-utilizr/lib/arrayUnique');

var _arrayUnique2 = _interopRequireDefault(_arrayUnique);

var _arrayRepeat = require('d2-utilizr/lib/arrayRepeat');

var _arrayRepeat2 = _interopRequireDefault(_arrayRepeat);

var _uuid = require('d2-utilizr/lib/uuid');

var _uuid2 = _interopRequireDefault(_uuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var PivotTableAxis = exports.PivotTableAxis = function PivotTableAxis(refs, layout, response, type) {

    var ignoreKeys = ['dy', 'longitude', 'latitude'];

    var spanType = void 0,
        aDimensions = [],
        nAxisWidth = 1,
        nAxisHeight = void 0,
        aUniqueFloorWidth = [],
        aAccFloorWidth = [],
        aFloorSpan = [],
        aCondoId = [],
        uuidObjectMap = {};

    if (type === 'col') {
        aDimensions = (layout.columns || []).filter(function (dim) {
            return !(0, _arrayContains2.default)(ignoreKeys, dim.dimension);
        });
        spanType = 'colSpan';
    } else if (type === 'row') {
        aDimensions = (layout.rows || []).filter(function (dim) {
            return !(0, _arrayContains2.default)(ignoreKeys, dim.dimension);
        });
        spanType = 'rowSpan';
    }

    if (!((0, _isArray2.default)(aDimensions) && aDimensions.length)) {
        return;
    }

    var dimensionNameIdsMap = layout.getDimensionNameIdsMap(response),
        tableSize = Object.keys(dimensionNameIdsMap).reduce(function (sum, id) {
        return sum * dimensionNameIdsMap[id].length;
    }, 1);

    var aaUniqueFloorIds = function () {
        var dims = void 0;

        return aDimensions.map(function (dimension, index) {
            if (dimension.sorted) dims = (0, _arrayPluck2.default)(dimension.items, 'id');else dims = dimensionNameIdsMap[dimension.dimension];

            nAxisWidth *= dims.length;
            aUniqueFloorWidth.push(dims.length);
            aAccFloorWidth.push(nAxisWidth);

            return dims;
        });
    }();

    nAxisHeight = aaUniqueFloorIds.length;

    for (var i = 0; i < nAxisHeight; i++) {
        aFloorSpan.push(nAxisWidth / aAccFloorWidth[i]);
    }

    var aaGuiFloorIds = aaUniqueFloorIds.map(function (ids, index) {
        return (0, _arrayRepeat2.default)(ids, aAccFloorWidth[index - 1]);
    });

    var aaAllFloorIds = aaGuiFloorIds.map(function (id, index) {
        return (0, _arrayRepeat2.default)(id, aFloorSpan[index], true);
    });

    var aaAllFloorObjects = aaAllFloorIds.map(function (ids, i) {

        var siblingPosition = 0,
            oldestObj = void 0;

        return ids.map(function (id, j) {

            var obj = {
                id: aaAllFloorIds[i][j],
                uuid: (0, _uuid2.default)(),
                dim: i,
                leaf: i === aaAllFloorIds.length - 1,
                axis: type,
                isOrganisationUnit: response.hasIdByDimensionName(aaAllFloorIds[i][j], 'ou')
            };

            uuidObjectMap[obj.uuid] = obj;

            if (j % aFloorSpan[i] === 0) {
                obj[spanType] = aFloorSpan[i];
                obj.children = obj.leaf ? 0 : null;
                obj.oldest = true;
                obj.root = i === 0;
                oldestObj = obj;
                siblingPosition = 0;
            }

            obj.oldestSibling = oldestObj;
            obj.siblingPosition = siblingPosition++;

            if (aaUniqueFloorIds.length - 1 > i) {
                obj.children = aaUniqueFloorIds[i + 1].length;
            }

            return obj;
        });
    });

    // add parents if more than 1 floor
    if (nAxisHeight > 1) {
        for (var _i = 1, aAllFloor; _i < nAxisHeight; _i++) {
            aAllFloor = aaAllFloorObjects[_i];

            //for (let j = 0, obj, doorCount = 0, span = aFloorSpan[i - 1], parentObj = aaAllFloorObjects[i - 1][0]; j < aAllFloor.length; j++) {
            for (var j = 0, doorCount = 0, span = aFloorSpan[_i - 1]; j < aAllFloor.length; j++) {
                aAllFloor[j].parent = aaAllFloorObjects[_i - 1][j];
            }
        }
    }

    var _loop = function _loop(_ids, _i2) {
        _ids = aaAllFloorIds.map(function (id) {
            return id[_i2];
        });

        if (_ids.length) {
            aCondoId.push(_ids.join('-'));
        }
        ids = _ids;
    };

    for (var _i2 = 0, ids; _i2 < nAxisWidth; _i2++) {
        _loop(ids, _i2);
    }

    // add uuids array to leaves
    if (aaAllFloorObjects.length) {

        // set span to second lowest span number: if aFloorSpan == [15,3,15,1], set span to 3
        var nSpan = nAxisHeight > 1 ? (0, _arraySort2.default)(aFloorSpan.slice())[1] : nAxisWidth,
            aAllFloorObjectsLast = aaAllFloorObjects[aaAllFloorObjects.length - 1];

        for (var _i3 = 0, leaf, parentUuids, obj, leafUuids = []; _i3 < aAllFloorObjectsLast.length; _i3++) {
            leaf = aAllFloorObjectsLast[_i3];
            leafUuids.push(leaf.uuid);
            obj = leaf;
            parentUuids = [];

            // get the uuid of the oldest sibling
            while (obj = obj.parent) {
                parentUuids.push(!obj.root && obj.oldestSibling ? obj.oldestSibling.uuid : obj.uuid);
            }

            // add parent uuids to leaf
            leaf.uuids = parentUuids.slice();

            // add uuid for all leaves
            if (leafUuids.length === nSpan) {
                for (var _j = _i3 - nSpan + 1, _leaf; _j <= _i3; _j++) {
                    var _leaf$uuids;

                    _leaf = aAllFloorObjectsLast[_j];
                    (_leaf$uuids = _leaf.uuids).push.apply(_leaf$uuids, _toConsumableArray(leafUuids));
                }

                leafUuids = [];
            }
        }
    }

    return {
        type: type,
        items: aDimensions,
        xItems: {
            unique: aaUniqueFloorIds,
            gui: aaGuiFloorIds,
            all: aaAllFloorIds
        },
        objects: {
            all: aaAllFloorObjects
        },
        ids: aCondoId,
        span: aFloorSpan,
        dims: nAxisHeight,
        size: nAxisWidth,
        uuidObjectMap: uuidObjectMap
    };
};
//# sourceMappingURL=PivotTableAxis.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/table/PivotTableAxis.js
 ** module id = 159
 ** module chunks = 0 1
 **/